import React, {useState} from 'react';
import PropTypes from 'prop-types'
import MapModal from "../components/Map/MapModal";
import Portal from "../components/Map/Portal";
import {parseInt} from "lodash/string";

function AccommodationMapApp ({ accommodations, openMapLink }) {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedAccommodation, setSelectedAccommodation] = useState(null);

    function openModal(accommodationUid) {
        setModalIsOpen(true);

        if (accommodationUid) {
            const filterSelectedAccommodation = accommodations
                .filter((selectedAccommodation) => selectedAccommodation.uid === parseInt(accommodationUid))
                .reduce((acc, item) => acc + item)

            setSelectedAccommodation(filterSelectedAccommodation)
        }
    }

    function closeModal() {
        setModalIsOpen(false);
        setSelectedAccommodation(null)
    }

    return (
            <div>
                {openMapLink.map((domNode, index) => <Portal openModal={openModal} domNode={domNode} key={index}/>)}

                {modalIsOpen &&
                    <MapModal
                        modalIsOpen={modalIsOpen}
                        closeModal={closeModal}
                        accommodations={accommodations}
                        selectedAccommodation={selectedAccommodation}
                        setSelectedAccommodation={setSelectedAccommodation}
                    />
                }
            </div>
    );
}

AccommodationMapApp.propTypes = {
    accommodations: PropTypes.array,
    openMapLink: PropTypes.array
};

export default AccommodationMapApp;



// WEBPACK FOOTER //
// ./src/apps/AccommodationMapApp.js